export enum DefaultNotifications {
    NotificationType = "Notification type"
}
